module.exports = __webpack_public_path__ + "img/mbp.1f6b5dbb.svg";